import ApiLibrary from "./ApiLibrary";

class RecruiterJobMetric extends ApiLibrary.Base {
  static className = "RecruiterJobMetric";

  static define() {}
}

export default ApiLibrary.createResource(RecruiterJobMetric);
